export default __webpack_public_path__ + "static/media/NotiTick.a00654f5.svg";